import styled from 'styled-components';

import { Table, theme } from 'components';
import { buildCssProp } from 'utils';

const StyledTable = styled(Table)<{
  $height?: string;
  $headerHeight?: number;
}>`
  tr:not([aria-disabled='true']) {
    cursor: pointer;
  }
  tr[aria-disabled='true']:hover > td {
    background-color: ${theme.gray1};
  }
  && th {
    text-transform: uppercase;
    color: ${theme.gray7};
  }
  &&
    > .ant-spin-nested-loading
    > .ant-spin-container
    > .ant-table
    > .ant-table-container {
    min-height: 300px;
    ${({ $height }) => buildCssProp('height', $height)}
  }
  &&
    > .ant-spin-nested-loading
    > .ant-spin-container
    > .ant-table
    > .ant-table-container
    > .ant-table-body {
    /* Default is scroll but on Windows unnecessary scroll bar looks bad */
    overflow: auto !important;
    ${({ $headerHeight }) =>
      buildCssProp(
        'height',
        ($headerHeight || $headerHeight === 0) &&
          `calc(100% - ${$headerHeight}px)`,
      )};
  }
`;

export default StyledTable;
